import { cn } from "../../lib/utils";
import Icon from "../common/Icon";

export const ServiceCard = ({ service, className }) => {
    return (
      <div className={cn("group relative bg-white border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden", className)}>
        <div className="h-48 overflow-hidden relative">
             <div className="absolute inset-0 bg-primary/20 group-hover:bg-primary/0 transition-colors z-10"></div>
             <img 
              src={service.image} 
              alt={service.title} 
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
        </div>
        <div className="p-6 relative">
          <div className="absolute top-0 right-0 -mt-6 mr-6 bg-primary text-white p-3 shadow-lg group-hover:-translate-y-2 transition-transform duration-300 flex items-center justify-center">
             <Icon name={service.icon} size={24} className="text-white" />
          </div>
          <h3 className="text-xl font-display font-bold text-foreground mb-3 uppercase group-hover:text-primary transition-colors">
            {service.title}
          </h3>
          <p className="text-muted-foreground text-sm leading-relaxed mb-4">
            {service.description}
          </p>
          <ul className="space-y-2 mb-6">
            {service.features.slice(0, 3).map((feature, idx) => (
                <li key={idx} className="text-xs text-gray-500 flex items-center gap-2">
                    <span className="h-1.5 w-1.5 bg-secondary rounded-full"></span>
                    {feature}
                </li>
            ))}
          </ul>
          <div className="w-full h-1 bg-gray-100 mt-auto overflow-hidden">
             <div className="h-full bg-primary w-0 group-hover:w-full transition-all duration-500 ease-out"></div>
          </div>
        </div>
      </div>
    );
  };
